module.exports = __webpack_public_path__ + "img/plus-circle.48127341.svg";